import { render, staticRenderFns } from "./menu_sites.vue?vue&type=template&id=5b9b636d"
import script from "./menu_sites.js?vue&type=script&lang=js&external"
export * from "./menu_sites.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports